export default "__VITE_ASSET__mCQlR4ca__"